// import { getLogger } from 'utils/logger';
import { REDUCER_KEY } from './reducer';
// const log = getLogger('data/documents/selector.js');

export const MAX_TX_ATTACHMENTS = 5;

export const getDocumentsStore = (state) => state[REDUCER_KEY];
export const getLastSyncDate = (state: any) => getDocumentsStore(state).lastSyncDate;

export const getDocuments = (state) => {
  const newState = getDocumentsStore(state);
  return newState.resourcesById;
};

export function getDocumentById(state, id) {
  if (state.resourcesById) {
    return state.resourcesById.find((x) => (String(x.id) === String(id))) || null;
  }
  return null;
}

